import React from 'react';
import cn from 'classnames';
import PointsIcon from '@wix/da-ds/pkg/Icons/Points';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';

import s from './CommissionPointsAndPrice.scss';

export interface Props {
  points?: number;
  price: string;
  dollarsClassName?: string;
  pointsClassName?: string;
}

const CommissionPointsAndPrice: React.FC<Props> = ({
  points,
  price,
  dollarsClassName,
  pointsClassName,
}) => {
  return (
    <div className={s['root']}>
      <div className={cn(s['dollars-price'], dollarsClassName)}>{price}</div>
      {points && (
        <div className={cn(s['points-price'], pointsClassName)}>
          <PointsIcon
            className={s['points-icon']}
            size={IconSize.TINY}
            disableDefaultColors
          />
          {points}
        </div>
      )}
    </div>
  );
};

CommissionPointsAndPrice.displayName = 'CommissionPointsAndPrice';

export default CommissionPointsAndPrice;
